import { LOAD_NOTIFICATION_SETTING, SAVE_NOTIFICATION_SETTING } from './actions'

const initialState = {
  settings: {
    parking: true,
    speed_over: true,
    driving_4hr: true,
    driving_10hr: true,
    aggressive: true,
  },
  loading: false,
  saving: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NOTIFICATION_SETTING.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_NOTIFICATION_SETTING.SUCCESS:
      return {
        ...state,
        settings: action.payload.settings,
        loading: false,
      }

    case LOAD_NOTIFICATION_SETTING.FAILURE:
      return {
        ...state,
        loading: false,
      }

    case SAVE_NOTIFICATION_SETTING.REQUEST:
      return {
        ...state,
        saving: true,
      }

    case SAVE_NOTIFICATION_SETTING.SUCCESS:
      return {
        ...state,
        settings: action.payload.settings,
        saving: false,
      }

    case SAVE_NOTIFICATION_SETTING.FAILURE:
      return {
        ...state,
        saving: false,
      }

    default:
      return state
  }
}
